import {
    SCHEDULED_ACTIONS_OPEN_MODAL,
    SCHEDULED_ACTIONS_REQUEST,
    SCHEDULED_ACTIONS_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    loading: false,
    ids: [],
    result: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case SCHEDULED_ACTIONS_OPEN_MODAL:
            return { ...state, openModal: true, ids: action.payload }

        case SCHEDULED_ACTIONS_REQUEST:
            return { ...state, loading: true }

        case SCHEDULED_ACTIONS_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "SCHEDULED_ACTIONS"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};